import React from "react"
import { useTranslation } from "react-i18next"
import ExportFromTable from "../../utils/Export/ExportFromTable"

interface HeaderParams {
    title: string
    subtitle?: string
    children: JSX.Element | JSX.Element[]
    records?: number
    data: Record<string, any>[] | Record<string, any>
    name?: string
    buttonId?: any
    type?: string
    disableExport?: boolean
    renderExtraControls?: JSX.Element
}

const Header = ({
    title,
    subtitle,
    children,
    records,
    data,
    name,
    buttonId,
    type,
    disableExport = false,
    renderExtraControls
}: HeaderParams) => {
    const { t } = useTranslation()
    return (
        <div className="header_container d-flex flex-column pt-2">
            <p></p>
            <hr></hr>
            <div className="d-flex justify-content-between align-items-center mt-3 px-2 header">
                <div className="d-flex justify-content-start align-items-center heading_title">
                    <h1 className="table-header-title">
                        {t(title)}
                        &nbsp;-&nbsp;{subtitle && <span className="font-weight-light">{t(subtitle)}</span>}
                    </h1>
                    {records && (
                        <div className="table-header-number-of-items mx-3 pb-1 align-self-end">
                            {records} {!type ? t("records") : ""}
                        </div>
                    )}
                </div>
                {!type && !disableExport && (
                    <div className="d-flex justify-content-end">
                        {children}
                        {buttonId && <ExportFromTable buttonId={buttonId} csvData={data} fileName={name} />}
                    </div>
                )}
                {renderExtraControls ?? null}
            </div>
        </div>
    )
}

export default Header
